import { useNavigate } from 'react-router-dom';
import './BookingConfirmation.css';

const BookingConfirmation = () => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/');
  };

  return (
    <div className="booking-confirmation">
      <div className="confirmation-content">
        <h1>Booking Confirmed!</h1>
        <p>Your booking has been successfully confirmed.</p>
        <button className="home-button" onClick={handleHomeClick}>
          Home
        </button>
      </div>
    </div>
  );
};

export default BookingConfirmation;
